function stateManagerKey(endpoint, version) {
  return `react-list--${endpoint}--${version}`;
}

export const stateManager = {
  init(context) {
    const { endpoint, version } = context;
    const latestKey = stateManagerKey(endpoint, version);
    const storageKeyBase = String(version || "").replace(/\d+$/, "");
    const targetPrefix = storageKeyBase
      ? `react-list--${endpoint}--${storageKeyBase}`
      : `react-list--${endpoint}--`;

    // Remove stale keys for this endpoint/storageKey
    const staleKeys = Object.keys(localStorage).filter(
      (key) => key.startsWith(targetPrefix) && key !== latestKey
    );
    staleKeys.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // Ignore localStorage errors
      }
    });
  },

  set(context) {
    const {
      endpoint,
      version,
      search,
      page,
      perPage,
      sortBy,
      sortOrder,
      filters,
    } = context;

    const key = stateManagerKey(endpoint, version);

    try {
      localStorage.setItem(
        key,
        JSON.stringify({
          search,
          page,
          perPage,
          sortBy,
          sortOrder,
          filters,
          timestamp: Date.now(), // Optional: for cache invalidation
        })
      );
    } catch (error) {
      console.warn("Failed to save state to localStorage:", error);
    }
  },

  get(context) {
    const { endpoint, version } = context;
    const key = stateManagerKey(endpoint, version);

    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        return JSON.parse(stored);
      }
      return null;
    } catch (error) {
      console.warn("Failed to retrieve state from localStorage:", error);
      return null;
    }
  },

  clear(context) {
    const { endpoint, version } = context;
    const key = stateManagerKey(endpoint, version);

    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn("Failed to clear state from localStorage:", error);
    }
  },
};
